/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EseguiTransazioneArticoloDTO } from '../model/eseguiTransazioneArticoloDTO';
import { EseguiTransazioneDTO } from '../model/eseguiTransazioneDTO';
import { EseguiTransazioneErrataCorrigeDTO } from '../model/eseguiTransazioneErrataCorrigeDTO';
import { EseguiTransazioniArticoliDTO } from '../model/eseguiTransazioniArticoliDTO';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { InlineResponse500 } from '../model/inlineResponse500';
import { PageTransazioneInfoDTO } from '../model/pageTransazioneInfoDTO';
import { TransazioniStatsDTO } from '../model/transazioniStatsDTO';
import { VoucherArticoliCheckDTO } from '../model/voucherArticoliCheckDTO';
import { VoucherCheckDTO } from '../model/voucherCheckDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TransazioniControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Consente di visualizzare la lista delle transazioni eventualmente filtrate
     * @param id_slug_comune 
     * @param page 
     * @param size 
     * @param codicePratica 
     * @param codicePraticaCittadino 
     * @param codiceVoucher 
     * @param idNegozio 
     * @param cassiere 
     * @param dateFrom 
     * @param dateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAll(id_slug_comune: string, page: number, size?: number, codicePratica?: string, codicePraticaCittadino?: string, codiceVoucher?: string, idNegozio?: string, cassiere?: string, dateFrom?: Date, dateTo?: Date, observe?: 'body', reportProgress?: boolean): Observable<PageTransazioneInfoDTO>;
    public getAll(id_slug_comune: string, page: number, size?: number, codicePratica?: string, codicePraticaCittadino?: string, codiceVoucher?: string, idNegozio?: string, cassiere?: string, dateFrom?: Date, dateTo?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageTransazioneInfoDTO>>;
    public getAll(id_slug_comune: string, page: number, size?: number, codicePratica?: string, codicePraticaCittadino?: string, codiceVoucher?: string, idNegozio?: string, cassiere?: string, dateFrom?: Date, dateTo?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageTransazioneInfoDTO>>;
    public getAll(id_slug_comune: string, page: number, size?: number, codicePratica?: string, codicePraticaCittadino?: string, codiceVoucher?: string, idNegozio?: string, cassiere?: string, dateFrom?: Date, dateTo?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAll.');
        }

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getAll.');
        }









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (codicePratica !== undefined && codicePratica !== null) {
            queryParameters = queryParameters.set('codicePratica', <any>codicePratica);
        }
        if (codicePraticaCittadino !== undefined && codicePraticaCittadino !== null) {
            queryParameters = queryParameters.set('codicePraticaCittadino', <any>codicePraticaCittadino);
        }
        if (codiceVoucher !== undefined && codiceVoucher !== null) {
            queryParameters = queryParameters.set('codiceVoucher', <any>codiceVoucher);
        }
        if (idNegozio !== undefined && idNegozio !== null) {
            queryParameters = queryParameters.set('idNegozio', <any>idNegozio);
        }
        if (cassiere !== undefined && cassiere !== null) {
            queryParameters = queryParameters.set('cassiere', <any>cassiere);
        }
        if (dateFrom !== undefined && dateFrom !== null) {
            queryParameters = queryParameters.set('dateFrom', <any>dateFrom.toISOString());
        }
        if (dateTo !== undefined && dateTo !== null) {
            queryParameters = queryParameters.set('dateTo', <any>dateTo.toISOString());
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PageTransazioneInfoDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/transazioni`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di visualizzare la lista delle proprie transazioni da parte di un cassiere
     * @param id_slug_comune 
     * @param page 
     * @param size 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllByCassiere(id_slug_comune: string, page: number, size?: number, observe?: 'body', reportProgress?: boolean): Observable<PageTransazioneInfoDTO>;
    public getAllByCassiere(id_slug_comune: string, page: number, size?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageTransazioneInfoDTO>>;
    public getAllByCassiere(id_slug_comune: string, page: number, size?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageTransazioneInfoDTO>>;
    public getAllByCassiere(id_slug_comune: string, page: number, size?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAllByCassiere.');
        }

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getAllByCassiere.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PageTransazioneInfoDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/transazioni/cassiere`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di ottenere le statistiche relative alle transazioni eseguite
     * @param id_slug_comune 
     * @param idNegozio 
     * @param codicePratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTransazioniStats(id_slug_comune: string, idNegozio?: string, codicePratica?: string, observe?: 'body', reportProgress?: boolean): Observable<TransazioniStatsDTO>;
    public getTransazioniStats(id_slug_comune: string, idNegozio?: string, codicePratica?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransazioniStatsDTO>>;
    public getTransazioniStats(id_slug_comune: string, idNegozio?: string, codicePratica?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransazioniStatsDTO>>;
    public getTransazioniStats(id_slug_comune: string, idNegozio?: string, codicePratica?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getTransazioniStats.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idNegozio !== undefined && idNegozio !== null) {
            queryParameters = queryParameters.set('idNegozio', <any>idNegozio);
        }
        if (codicePratica !== undefined && codicePratica !== null) {
            queryParameters = queryParameters.set('codicePratica', <any>codicePratica);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TransazioniStatsDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/transazioni/stats/get`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di sottomettere una nuova transazione da parte di un cassiere
     * @param body 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sottomettiTransazione(body: EseguiTransazioneDTO, id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<VoucherCheckDTO>;
    public sottomettiTransazione(body: EseguiTransazioneDTO, id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VoucherCheckDTO>>;
    public sottomettiTransazione(body: EseguiTransazioneDTO, id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VoucherCheckDTO>>;
    public sottomettiTransazione(body: EseguiTransazioneDTO, id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling sottomettiTransazione.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling sottomettiTransazione.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<VoucherCheckDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/transazioni`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di sottomettere una nuova transazione su un articolo da parte di un cassiere
     * @param body 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sottomettiTransazioneArticolo(body: EseguiTransazioneArticoloDTO, id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<VoucherArticoliCheckDTO>;
    public sottomettiTransazioneArticolo(body: EseguiTransazioneArticoloDTO, id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VoucherArticoliCheckDTO>>;
    public sottomettiTransazioneArticolo(body: EseguiTransazioneArticoloDTO, id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VoucherArticoliCheckDTO>>;
    public sottomettiTransazioneArticolo(body: EseguiTransazioneArticoloDTO, id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling sottomettiTransazioneArticolo.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling sottomettiTransazioneArticolo.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<VoucherArticoliCheckDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/transazioni/articolo`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di sottomettere una nuova transazione di errata corrige
     * @param body 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sottomettiTransazioneErrataCorrige(body: EseguiTransazioneErrataCorrigeDTO, id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<VoucherCheckDTO>;
    public sottomettiTransazioneErrataCorrige(body: EseguiTransazioneErrataCorrigeDTO, id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VoucherCheckDTO>>;
    public sottomettiTransazioneErrataCorrige(body: EseguiTransazioneErrataCorrigeDTO, id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VoucherCheckDTO>>;
    public sottomettiTransazioneErrataCorrige(body: EseguiTransazioneErrataCorrigeDTO, id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling sottomettiTransazioneErrataCorrige.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling sottomettiTransazioneErrataCorrige.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<VoucherCheckDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/transazioni/erratacorrige`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di sottomettere una lista di transazioni su più articoli contemporaneamente da parte di un cassiere
     * @param body 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sottomettiTransazioniArticoli(body: EseguiTransazioniArticoliDTO, id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<VoucherArticoliCheckDTO>;
    public sottomettiTransazioniArticoli(body: EseguiTransazioniArticoliDTO, id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VoucherArticoliCheckDTO>>;
    public sottomettiTransazioniArticoli(body: EseguiTransazioniArticoliDTO, id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VoucherArticoliCheckDTO>>;
    public sottomettiTransazioniArticoli(body: EseguiTransazioniArticoliDTO, id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling sottomettiTransazioniArticoli.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling sottomettiTransazioniArticoli.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<VoucherArticoliCheckDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/transazioni/articoli`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
